<div class="wide">
  <p-card class="custom-card admin-panel-user-preview-table overflow-hidden">
    <div class="table-section-title mb-6">Organizacje</div>

    <p-table
      #table
      (onPage)="onPrimePageChange($event)"
      (onSort)="onPrimeSortChange($event)"
      [customSort]="true"
      [lazy]="true"
      [loading]="isDataLoading()"
      [paginator]="true"
      [paginatorStyleClass]="'customPrimePaginator'"
      [rowsPerPageOptions]="[5, 10, 25]"
      [rows]="tablePage()?.size || 5"
      [tableStyle]="{ 'min-width': '70rem' }"
      [totalRecords]="tablePage()?.totalElements || 0"
      [value]="rows()"
      class="customPrimeTable user-preview"
      scrollHeight="flex"
      [scrollable]="true"
      paginatorDropdownAppendTo="body"
    >
        <ng-template #header>
          <tr>
            <th pSortableColumn="name">
              <div class="flex items-center gap-2">
                Nazwa
                <p-sortIcon field="name" />
              </div>
            </th>
            <th pSortableColumn="nip" class="w-35 min-w-35 max-w-35">
              <div class="flex items-center gap-2">
                NIP
                <p-sortIcon field="nip" />
              </div>
            </th>
            <th pSortableColumn="regon" class="identifier-column">
              <div class="flex items-center gap-2">
                REGON
                <p-sortIcon field="regon" />
              </div>
            </th>
            <th pSortableColumn="pesel" class="identifier-column">
              <div class="flex items-center gap-2">
                PESEL
                <p-sortIcon field="pesel" />
              </div>
            </th>
            <th pSortableColumn="role" class="role-column">
              <div class="flex items-center gap-2">
                Rola
                <p-sortIcon field="role" />
              </div>
            </th>
            <th>
              <div class="flex items-center gap-2">Instytucja</div>
            </th>
            <th alignFrozen="right" pFrozenColumn class="actions-column">
              Akcje
            </th>
          </tr>
          <tr>
            <td class="table-filter-cell">
              <input
                (change)="onPrimeFilterChange($event.target, 'name')"
                aria-label="Filtruj po nazwie"
                pInputText
                [(ngModel)]="tableFilters.name"
              />
            </td>
            <td class="table-filter-cell w-35 min-w-35 max-w-35">
              <input
                (change)="onPrimeFilterChange($event.target, 'nip')"
                aria-label="Filtruj po NIP"
                pInputText
                class="w-full min-w-0"
                [(ngModel)]="tableFilters.nip"
              />
            </td>
            <td class="table-filter-cell identifier-column">
              <input
                (change)="onPrimeFilterChange($event.target, 'regon')"
                aria-label="Filtruj po REGON"
                pInputText
                [(ngModel)]="tableFilters.regon"
              />
            </td>
            <td class="table-filter-cell identifier-column">
              <input
                (change)="onPrimeFilterChange($event.target, 'pesel')"
                aria-label="Filtruj po PESEL"
                pInputText
                [(ngModel)]="tableFilters.pesel"
              />
            </td>
            <td class="table-filter-cell">
              <p-select
                (onChange)="onPrimeFilterChange($event.value ?? '', 'role')"
                [options]="roleOptions"
                [showClear]="true"
                [(ngModel)]="tableFilters.role"
                placeholder="Wybierz rolę"
                appendTo="body"
                class="w-full role-filter-select"
              ></p-select>
            </td>
            <td class="table-filter-cell">
              <input
                (change)="onPrimeFilterChange($event.target, 'institutionType')"
                aria-label="Filtruj po instytucji"
                pInputText
                [(ngModel)]="tableFilters.institutionType"
              />
            </td>
            <td
              alignFrozen="right"
              pFrozenColumn
              class="table-filter-cell actions-filter-cell actions-column"
            ></td>
          </tr>
        </ng-template>
        <ng-template #body let-row>
          <tr>
            <td>{{ row.name }}</td>
            <td class="w-35 min-w-35 max-w-35">{{ row.nip }}</td>
            <td class="identifier-column">{{ row.regon }}</td>
            <td class="identifier-column">{{ row.pesel }}</td>
            <td class="role-column">
              {{ row.role | organizationRepresentativeRoleLabel }}
            </td>
            <td>
              <div class="institution-cell">
                <span>{{ getInstitutionPreview(row.institutionType) }}</span>
                @if (getInstitutionHiddenCount(row.institutionType) > 0) {
                  <span
                    class="institution-more"
                    tabindex="0"
                    (mouseenter)="
                      showInstitutionPopover(
                        $event,
                        institutionPopover,
                        row.institutionType
                      )
                    "
                    (click)="
                      showInstitutionPopover(
                        $event,
                        institutionPopover,
                        row.institutionType
                      )
                    "
                    (keydown.enter)="
                      showInstitutionPopover(
                        $event,
                        institutionPopover,
                        row.institutionType
                      )
                    "
                    (keydown.space)="
                      showInstitutionPopover(
                        $event,
                        institutionPopover,
                        row.institutionType
                      )
                    "
                  >
                    +{{ getInstitutionHiddenCount(row.institutionType) }} więcej
                  </span>
                }
              </div>
            </td>
            <td
              alignFrozen="right"
              pFrozenColumn
              class="h-16 align-middle actions-column"
            >
              <div class="flex items-center gap-3">
                <p-button
                  ariaLabel="Zobacz szczegóły"
                  icon="pi pi-eye"
                  pTooltip="Zobacz szczegóły"
                  tooltipPosition="top"
                  [rounded]="true"
                  [text]="true"
                  (click)="showOrganizationDetails(row.id)"
                />
                @if ((row.attachments?.length ?? 0) > 0) {
                  <p-button
                    ariaLabel="Pobierz"
                    icon="pi pi-download"
                    pTooltip="Pobierz"
                    tooltipPosition="top"
                    [rounded]="true"
                    [text]="true"
                    (click)="downloadOrganizationDocument(row)"
                  />
                }
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="7">Brak danych.</td>
          </tr>
        </ng-template>
    </p-table>

    <p-popover
      #institutionPopover
      appendTo="body"
      styleClass="institution-copy-popover"
      [style]="{ maxWidth: 'min(36rem, calc(100vw - 2rem))' }"
    >
      <div class="institution-popover-content">
        @for (item of institutionPopoverItems; track item) {
          <div class="institution-popover-item">{{ item }}</div>
        }
      </div>
    </p-popover>
  </p-card>
</div>

<div class="narrow">
  <p-card class="custom-card overflow-hidden">
    <div class="table-section-title mb-6">Organizacje</div>

    <p-card class="mb-4">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <label for="organizationNameMobile" class="font-bold">Nazwa</label>
          <input
            id="organizationNameMobile"
            (input)="onPrimeFilterChangeMobile($event.target, 'name')"
            pInputText
            class="w-full"
            [(ngModel)]="tableFilters.name"
          />
        </div>
        <div class="flex flex-col gap-2">
          <label for="organizationNipMobile" class="font-bold">NIP</label>
          <input
            id="organizationNipMobile"
            (input)="onPrimeFilterChangeMobile($event.target, 'nip')"
            pInputText
            class="w-full"
            [(ngModel)]="tableFilters.nip"
          />
        </div>
        <div class="flex flex-col gap-2">
          <label for="organizationRegonMobile" class="font-bold">REGON</label>
          <input
            id="organizationRegonMobile"
            (input)="onPrimeFilterChangeMobile($event.target, 'regon')"
            pInputText
            class="w-full"
            [(ngModel)]="tableFilters.regon"
          />
        </div>
        <div class="flex flex-col gap-2">
          <label for="organizationPeselMobile" class="font-bold">PESEL</label>
          <input
            id="organizationPeselMobile"
            (input)="onPrimeFilterChangeMobile($event.target, 'pesel')"
            pInputText
            class="w-full"
            [(ngModel)]="tableFilters.pesel"
          />
        </div>
        <div class="flex flex-col gap-2">
          <label for="organizationRoleMobile" class="font-bold">Rola</label>
          <p-select
            inputId="organizationRoleMobile"
            (onChange)="onPrimeFilterChange($event.value ?? '', 'role')"
            [options]="roleOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.role"
            placeholder="Wybierz rolę"
            appendTo="body"
            class="w-full"
          ></p-select>
        </div>
        <div class="flex flex-col gap-2">
          <label for="organizationInstitutionMobile" class="font-bold">
            Instytucja
          </label>
          <input
            id="organizationInstitutionMobile"
            (input)="
              onPrimeFilterChangeMobile($event.target, 'institutionType')
            "
            pInputText
            class="w-full"
            [(ngModel)]="tableFilters.institutionType"
          />
        </div>
        <div class="flex justify-end">
          <p-button
            type="button"
            label="Wyczyść filtry"
            styleClass="customInfoButton outlined"
            (click)="clearFilters()"
          />
        </div>
      </div>
    </p-card>

    <div class="flex flex-col gap-4">
      @for (row of rows(); track row.id) {
        <p-card>
          <div class="flex flex-col">
            <app-preview-data-wrapper
              label="Nazwa"
              [data]="row.name"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="NIP"
              [data]="row.nip"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="REGON"
              [data]="row.regon"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="PESEL"
              [data]="row.pesel"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Rola"
              [data]="row.role | organizationRepresentativeRoleLabel"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Instytucja"
              [data]="row.institutionType"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>

            <div class="mt-5 flex flex-wrap justify-end gap-2">
              <p-button
                label="Zobacz szczegóły"
                styleClass="customInfoButton outlined"
                (click)="showOrganizationDetails(row.id)"
              />
              @if ((row.attachments?.length ?? 0) > 0) {
                <p-button
                  label="Pobierz"
                  styleClass="customInfoButton outlined"
                  (click)="downloadOrganizationDocument(row)"
                />
              }
            </div>
          </div>
        </p-card>
      } @empty {
        <p-card>
          <span>-</span>
        </p-card>
      }
    </div>

    <div class="mt-4 flex flex-col items-end gap-2">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[5, 10, 25]"
        [rows]="tablePage()?.size || 5"
        [totalRecords]="tablePage()?.totalElements || 0"
        pageLinkSize="3"
        class="customPrimePaginator"
        appendTo="body"
      />
      <div class="text-sm">
        Strona {{ (tablePage()?.number || 0) + 1 }} z
        {{ tablePage()?.totalPages || 0 }}
      </div>
    </div>
  </p-card>
</div>
